export default "__VITE_PUBLIC_ASSET__50362fdc__"